import { useState } from "react";

export const useTwoStepAuthSetStates = () => {
  const [isValid, setIsValid] = useState(0); // 0: 無効 1: 有効


  return {
    isValid,
    setIsValid,
  };
};
